module.exports = __webpack_public_path__ + "img/24.56336f8a.jpg";